// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:16
import { CrisisComponentLink_abstract } from './../abstract/SagaSchema/CrisisComponentLink_abstract';
export class CrisisComponentLink extends CrisisComponentLink_abstract {}
